import React, { useEffect, useMemo, useState } from 'react'
import { Grid, Input, TextField } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import { useDispatch, useSelector } from 'react-redux'
import { AutoCompleteFonctionTableur } from './auto-complete-fonction-tableur'
import { getFormatedDate } from '../../../../../../conventions-collectives/workflow/inputs/cc-workflow-form-simple'
import { getDateToSave } from '../simple-cell-type'
import { getFlatThemeComponents } from '../../../../../../../store/selectors/component-selectors'
import { FonctionPopperDefinition } from './fonction-popper-definition'
import EditIcon from '@material-ui/icons/Edit'
import { GreyButton } from '../../../../../../common/grey-button.js'
import { Types } from '../../../../../../../store/constants/fonction/fonction'
import _ from 'lodash'
import { dataSelector } from '../list/tableur-cell-unit-of-list-exclusion'
import { getRenvoieResults } from '../../../../../../../store/actions/fonction/renvoie-action'
import { RenvoieResultsPopper } from './renvoie-results-popper'
import { RenvoieValues } from '../../../../../../../store/constants/RenvoieResult'
import { AddItemButtons } from '../../../../../../conventions-collectives/themes/add-item-buttons'
import { getFonctionAsSTR } from './parameter-field'

/*
BOOLEAN: { label: 'Booléen', validate: value => value.toLowerCase() === 'true' || value.toLowerCase() === 'false' },
NUMBER: { label: 'Nombre', validate: value => !isNaN(Number(value)) },
STRING: { label: 'Chaine de caractéres', validate: value => isNaN(Date.parse(value)) },
DATE: { label: 'Date', validate: value => Date.parse(value) },
BORNE: { label: 'Borne', validate: value => true },
REFERENCE: { label: 'Référentiel', validate: value => true },
*/

function getTextFromReferentiel(referentiels, param, valeurText) {
  console.log('referentiels', referentiels, param, valeurText)
  return referentiels
    .find(r => r.nom === param.parametre.reference)
    .valeurs.map(v => v.code + ' - ' + v.libelle)
    .find(r => r.startsWith(valeurText))
}

function getAllReferenceAsText(referentiels, param) {
  console.log('referentiel', referentiels, param)
  return referentiels.find(r => r.nom === param.parametre.reference).valeurs.map(v => v.code + ' - ' + v.libelle)
}

function getCondition(param, i) {
  console.log('param', param)
  console.log('i', i)
  console.log('i.nom', i.nom)
  console.log('type', Types[param.parametre.type])
  return Types[param.parametre.type].condition(i, param.parametre)
}

function getMap(themes, themeName, param, role) {
  return themes
    .find(t => t.nom === themeName)
    [role].filter(i => getCondition(param, i))
    .map(i => i.nom)
}

function getComps(theme, tmpThemeRenvoie, themes, param, role) {
  let themeName = !tmpThemeRenvoie ? theme.nom : tmpThemeRenvoie
  console.log('themeName', themeName)
  console.log('!tmpThemeRenvoie && !isCurrentTheme', !tmpThemeRenvoie && tmpThemeRenvoie)
  console.log('!tmpThemeRenvoie && !isCurrentTheme == > themes', themes)
  return !tmpThemeRenvoie && tmpThemeRenvoie ? [] : getMap(themes, themeName, param, role)
}

export function ParamDataPopperContent({
  className,
  handleChange,
  functionData,
  onCancel,
  classes,
  param,
  excludeFonctions,
  line,
  setParamValue,
  paramValue,
}) {
  const [tmpOrigine, setTmpOrigine] = useState(() => '')
  const [tmpValeurText, setTmpValeurText] = useState()
  const [tmpValeurNumber, setTmpValeurNumber] = useState()
  const [tmpValeurBoolean, setTmpValeurBoolean] = useState()
  const [tmpValeurDate, setTmpValeurDate] = useState()
  const [valeurBorne, setValeurBorne] = useState()
  const [tmpValeurFonction, setTmpValeurFonction] = useState()
  const [valeurRenvoie, setValeurRenvoie] = useState()
  const [tmpInputsOutputsRenvoie, setTmpInputsOutputsRenvoie] = useState()
  const [tmpCompRenvoie, setTmpCompRenvoie] = useState()
  const [anchorElFonction, setAnchorElFonction] = useState()
  const [anchorElRenvoie, setAnchorElRenvoie] = useState()
  const [tmpThemeRenvoie, setTmpThemeRenvoie] = useState()
  const [tmpConventionRenvoie, setTmpConventionRenvoie] = useState()
  const [tmpCustomInputs, setTmpCustomInputs] = useState([])
  const [tmpRenvoieValues, setTmpRenvoieValues] = useState()
  const [tmpFonctionParams, setTmpFonctionParams] = useState()

  const variablesClients = useSelector(state => state.variableClientModule.variableClients)
  const variablesContextes = useSelector(state => state.variableContexteModule.variableContextes)
  const referentiels = useSelector(state => state.tableurModule.referentiels)
  const cc = useSelector(state => state.conventionModule.conventionCollective)
  const ccs = useSelector(state => state.conventionModule.conventionsCollectives)
  const themes = useSelector(state => getFlatThemeComponents(state))
  const inputs = useSelector(state => state.tableurModule.inputs)
  const outputs = useSelector(state => state.tableurModule.outputs)
  const theme = useSelector(state => state.conventionModule.theme)
  const renvoieResults = useSelector(state => state.renvoieModule.renvoieResults)
  const data = useSelector(dataSelector(line), _.isEqual)

  const dispatch = useDispatch()

  useEffect(() => {
    if (paramValue) {
      console.log('paramValue', paramValue)
      setTmpOrigine(paramValue.origin)
      if (paramValue.origin === 'VALEUR_SAISIE') {
        console.log('paramType', param.parametre.type)
        if (param.parametre.type === 'NUMBER') setTmpValeurNumber(paramValue.numberValue)
        if (param.parametre.type === 'BOOLEAN') setTmpValeurBoolean(paramValue.booleanValue)
        if (param.parametre.type === 'DATE') setTmpValeurBoolean(paramValue.dateValue)
      } else if (param.parametre.type === 'FONCTION') setTmpFonctionParams(paramValue.valeurOrigine)
      else if (paramValue.origin === 'RENVOI') {
        console.log('setRenvoi', paramValue.renvoieValue)
        setTmpRenvoieValues(paramValue.renvoieValue)
        setTmpThemeRenvoie(paramValue.renvoieValue.theme)
        setTmpConventionRenvoie(paramValue.renvoieValue.idcc)
        setTmpCompRenvoie(paramValue.renvoieValue.component)
        setTmpInputsOutputsRenvoie(paramValue.renvoieValue.role)
      } else {
        console.log('paramValue', paramValue.textValue)
        setTmpValeurText(paramValue.textValue)
      }
    } else if (param.origineDefaut) {
      setTmpOrigine(param.origineDefaut)
      console.log('orgineDefaut', param.origineDefaut)
      console.log('param.parametres.type', param.parametre.type)
      console.log('param.parametres.type', param.valeurOrigine)
      if (param.origineDefaut === 'VALEUR_SAISIE') {
        if (param.parametre.type === 'NUMBER') setTmpValeurNumber(param.valeurOrigine)
        if (param.parametre.type === 'STRING') setTmpValeurText(param.valeurOrigine)
        if (param.parametre.type === 'BOOLEAN') setTmpValeurBoolean(param.valeurOrigine)
        if (param.parametre.type === 'DATE') setTmpValeurBoolean(param.valeurOrigine)
        if (param.parametre.type === 'REFERENCE') setTmpValeurText(param.valeurOrigine)
      }
      if (param.origineDefaut === 'CONTEXTE' || param.origineDefaut === 'VARIBALE_CLIENT')
        setTmpValeurText(param.valeurOrigine)
    }
  }, [param, paramValue])

  const innerHandleChange = (value, field) => {
    if (field === 'nomFonction') {
    }
  }

  const filtredVariableClients = useMemo(
    () => variablesClients.filter(v => v.type === param.parametre.type).map(v => v.nom),
    [variablesClients]
  )
  const filtredVariableContexts = useMemo(
    () => variablesContextes.filter(v => v.type === param.parametre.type).map(v => v.nom),
    [variablesContextes]
  )

  const setCustomInputNom = (nom, index) => {
    let xtmpCustomInputs = [...tmpCustomInputs]
    if (nom) xtmpCustomInputs[index] = { nom, value: '' }
    else xtmpCustomInputs.splice(index, 1)
    console.log('xtmpCustomInputs', xtmpCustomInputs)
    setTmpCustomInputs(xtmpCustomInputs)
    setTmpRenvoieValues(null)
  }

  const isVariableClient = useMemo(() => tmpOrigine === 'VARIBALE_CLIENT', [tmpOrigine])
  const isVariableContext = useMemo(() => tmpOrigine === 'CONTEXTE', [tmpOrigine])
  const isFonction = useMemo(() => tmpOrigine === 'FONCTION', [tmpOrigine])
  const isRenvoi = useMemo(() => tmpOrigine === 'RENVOI', [tmpOrigine])

  //'VALEUR_SAISIE', 'VARIBALE_CLIENT', 'RENVOI', 'CONTEXTE', 'FONCTION'
  const handleChangeOrigin = value => {
    setTmpOrigine(value ? value : '')
    setTmpValeurText(null)
    setTmpValeurNumber(null)
    setTmpValeurBoolean(null)
    setTmpValeurDate(null)
    setValeurBorne(null)
    setTmpValeurFonction(null)
    setValeurRenvoie(null)
    setTmpCompRenvoie(null)
    setTmpRenvoieValues(null)
  }

  /*
  BOOLEAN: { label: 'Booléen', validate: value => value.toLowerCase() === 'true' || value.toLowerCase() === 'false' },
  NUMBER: { label: 'Nombre', validate: value => !isNaN(Number(value)) },
  STRING: { label: 'Chaine de caractéres', validate: value => isNaN(Date.parse(value)) },
  DATE: { label: 'Date', validate: value => Date.parse(value) },
  BORNE: { label: 'Borne', validate: value => true },
  REFERENCE: { label: 'Référentiel', validate: value => true },
  */

  const open = useMemo(() => Boolean(anchorElFonction), [anchorElFonction])
  const handleAddCustomInput = () => {
    setTmpCustomInputs([...tmpCustomInputs, { nom: '', value: '' }])
  }
  const handleRefreshValues = () => {
    const payload = {
      dataRenvoie: {
        role: tmpInputsOutputsRenvoie,
        name: tmpCompRenvoie,
      },
      idccSource: cc.idcc,
      idccTarget: !tmpConventionRenvoie ? cc.idcc : tmpConventionRenvoie.split(' - ')[0],
      sourceThemeName: theme.nom,
      targetThemeName: !tmpThemeRenvoie ? theme.nom : tmpThemeRenvoie,
      inputs: data.inputs,
      customInputs: tmpCustomInputs.filter(ci => ci.nom).map(ci => ci.nom),
    }
    dispatch(getRenvoieResults(payload))
    setAnchorElRenvoie(true)
    console.log('payload', payload)
  }

  const themesNames = useMemo(() => themes.map(t => t.nom), [themes])
  const idccAndLabels = useMemo(() => ccs.map(cc => cc.idcc + ' - ' + cc.titre), [ccs])
  const inputNames = useMemo(() => {
    return getComps(theme, tmpThemeRenvoie, themes, param, 'inputs')
  }, [inputs, themes, tmpThemeRenvoie, tmpInputsOutputsRenvoie, theme])

  const allInputs = useMemo(() => {
    let find = themes.find(t => (!tmpThemeRenvoie ? t.nom === theme.nom : t.nom === tmpThemeRenvoie))
    return find ? find['inputs'].map(i => i.nom) : []
  }, [theme, tmpThemeRenvoie])
  const outputNames = useMemo(() => {
    if (tmpInputsOutputsRenvoie === 'INPUT' || !tmpInputsOutputsRenvoie) return []
    return getComps(theme, tmpThemeRenvoie, themes, param, 'outputs')
  }, [outputs, themes, tmpThemeRenvoie, tmpInputsOutputsRenvoie, theme])

  const handleChangeTheme = newTheme => {
    setTmpThemeRenvoie(newTheme === theme.nom ? null : newTheme)
    setTmpCompRenvoie(null)
    setTmpRenvoieValues(null)
  }
  const handleCCChange = newCC => {
    setTmpConventionRenvoie(newCC === cc.idcc ? null : newCC)
    setTmpRenvoieValues(null)
  }

  const selectValues = renvoieResult => {
    if (!renvoieResult) {
      setTmpRenvoieValues(null)
      return
    }
    let renvoieValues = new RenvoieValues(
      tmpInputsOutputsRenvoie,
      tmpCompRenvoie,
      tmpConventionRenvoie,
      tmpThemeRenvoie
    )
    renvoieResult.customData.forEach(cd => {
      renvoieValues.ids[cd.component] = cd.id
      renvoieValues.values[cd.component] = cd.data[cd.component]
    })
    setTmpRenvoieValues(renvoieValues)
    setAnchorElRenvoie(false)
  }

  const handleChangeComp = value => {
    setTmpCompRenvoie(value)
    if (!tmpThemeRenvoie && !tmpConventionRenvoie && !tmpCustomInputs.length) {
      setTmpRenvoieValues(new RenvoieValues(tmpInputsOutputsRenvoie, value, tmpConventionRenvoie, tmpThemeRenvoie))
    } else setTmpRenvoieValues(null)
  }

  const handleOnSave = () => {
    let value =
      tmpOrigine === 'VALEUR_SAISIE' && param.parametre.type === 'NUMBER'
        ? tmpValeurNumber
        : tmpOrigine === 'VALEUR_SAISIE' && param.parametre.type === 'BOOLEAN'
        ? tmpValeurBoolean
        : tmpOrigine === 'VALEUR_SAISIE' && param.parametre.type === 'DATE'
        ? tmpValeurDate
        : tmpOrigine === 'RENVOI'
        ? tmpRenvoieValues
        : tmpOrigine === 'FONCTION'
        ? tmpFonctionParams
        : tmpValeurText

    if (tmpOrigine === 'VALEUR_SAISIE') setValeurSaisie(value)
    else if (['VARIBALE_CLIENT', 'CONTEXTE'].includes(tmpOrigine))
      setParamValue(param.parametre.nom, {
        origin: tmpOrigine,
        textValue: value,
      })
    else if (tmpOrigine === 'RENVOI')
      setParamValue(param.parametre.nom, {
        origin: tmpOrigine,
        renvoieValue: value,
      })
    else if (tmpOrigine === 'FONCTION')
      setParamValue(param.parametre.nom, {
        origin: tmpOrigine,
        fonctionValue: value,
      })
  }

  const setValeurSaisie = value => {
    if (param.parametre.type === 'NUMBER')
      setParamValue(param.parametre.nom, {
        origin: tmpOrigine,
        numberValue: value,
      })
    else if (param.parametre.type === 'BOOLEAN')
      setParamValue(param.parametre.nom, {
        origin: tmpOrigine,
        booleanValue: value,
      })
    else if (param.parametre.type === 'DATE')
      setParamValue(param.parametre.nom, {
        origin: tmpOrigine,
        dateValue: value,
      })
    else if (param.parametre.type === 'FONCTION')
      setParamValue(param.parametre.nom, {
        origin: tmpOrigine,
        fonctionValue: value,
      })
    else
      setParamValue(param.parametre.nom, {
        origin: tmpOrigine,
        textValue: value,
      })
  }

  const isSaveDisabled = useMemo(() => {
    //'VALEUR_SAISIE', 'VARIBALE_CLIENT', 'RENVOI', 'CONTEXTE', 'FONCTION'
    if (tmpOrigine) {
      let res = true
      if (tmpOrigine === 'VALEUR_SAISIE') {
        if (param.parametre.type === 'STRING') res = !tmpValeurText
        if (param.parametre.type === 'NUMBER') res = tmpValeurNumber === null || tmpValeurNumber === undefined
        if (param.parametre.type === 'BOOLEAN') res = tmpValeurBoolean === null || tmpValeurBoolean === undefined
        if (param.parametre.type === 'DATE') res = !tmpValeurDate
        if (param.parametre.type === 'REFERENCE') res = !tmpValeurText
      }
      if (tmpOrigine === 'VARIBALE_CLIENT' || tmpOrigine === 'CONTEXTE') res = !tmpValeurText
      if (tmpOrigine === 'FONCTION') res = !tmpFonctionParams
      if (tmpOrigine === 'RENVOI') res = !tmpRenvoieValues
      return res
    }
    return true
  }, [
    tmpOrigine,
    tmpValeurText,
    tmpValeurNumber,
    tmpValeurBoolean,
    tmpValeurDate,
    tmpRenvoieValues,
    tmpValeurFonction,
    tmpFonctionParams,
  ])
  const handleSetBoolean = valeur => {
    return setTmpValeurBoolean(valeur === 'vrai')
  }
  return (
    <Grid item xs={12}>
      <Grid container direction="column" style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'clip' }}>
        <Grid item xs={12}>
          <Grid item xs={12}>
            <AutoCompleteFonctionTableur
              label="Origine"
              valeur={tmpOrigine}
              options={param.origines}
              setValeur={handleChangeOrigin}
            />
          </Grid>
          {tmpOrigine === 'VALEUR_SAISIE' && (
            <Grid item xs={12}>
              <InputLabel id="funciton_name_label">Valeur Saisie</InputLabel>
              {param.parametre.type === 'STRING' && (
                <Input
                  type="text"
                  value={tmpValeurText}
                  getOptionLabel={f => f}
                  style={{ width: '100%' }}
                  onChange={e => setTmpValeurText(e.target.value)}
                  label="Saisir valeur"
                />
              )}
              {param.parametre.type === 'NUMBER' && (
                <Input
                  type="number"
                  value={tmpValeurNumber}
                  getOptionLabel={f => f}
                  style={{ width: '100%' }}
                  onChange={e => setTmpValeurNumber(e.target.value)}
                  label="Saisir valeur"
                />
              )}
              {param.parametre.type === 'BOOLEAN' && (
                <AutoCompleteFonctionTableur
                  valeur={tmpValeurBoolean == null ? '' : tmpValeurBoolean ? 'vrai' : 'faux'}
                  options={['vrai', 'faux']}
                  setValeur={handleSetBoolean}
                />
              )}
              {param.parametre.type === 'DATE' && (
                <TextField
                  style={{ width: '100%' }}
                  helperText="Valeur Saisie"
                  variant="outlined"
                  value={getFormatedDate(tmpValeurDate)}
                  type="date"
                  onChange={e => setTmpValeurDate(getDateToSave(e.target.value))}
                />
              )}
              {param.parametre.type === 'REFERENCE' && (
                <Grid>
                  <TextField
                    style={{ width: '100%' }}
                    helperText="Reference"
                    value={param.parametre.reference}
                    type="text"
                    disabled
                  />
                  {
                    <AutoCompleteFonctionTableur
                      label="Valeur Saisie"
                      valeur={tmpValeurText}
                      inputValue={tmpValeurText ? getTextFromReferentiel(referentiels, param, tmpValeurText) : ''}
                      options={getAllReferenceAsText(referentiels, param)}
                      setValeur={v => {
                        setTmpValeurText(v ? v.split(' - ')[0] : v)
                      }}
                    />
                  }
                </Grid>
              )}
            </Grid>
          )}
          {isVariableClient && (
            <AutoCompleteFonctionTableur
              label="Variable client"
              valeur={tmpValeurText}
              options={filtredVariableClients}
              setValeur={setTmpValeurText}
            />
          )}
          {isVariableContext && (
            <AutoCompleteFonctionTableur
              label="Variable context"
              valeur={tmpValeurText}
              options={filtredVariableContexts}
              setValeur={setTmpValeurText}
            />
          )}
          {isFonction && (
            <Grid item xs={12}>
              <TextField
                data-test={param.nom + '_edit'}
                type={'text'}
                disabled
                label="Variable Fonction"
                InputProps={{
                  startAdornment: (
                    <>
                      <EditIcon
                        fontSize={'small'}
                        onClick={e => setAnchorElFonction(e.currentTarget)}
                        data-test="EDIT"
                        style={{ cursor: 'pointer', marginRight: 5 }}
                      />
                      {getFonctionAsSTR(tmpFonctionParams)}
                    </>
                  ),
                }}
              >
                test
              </TextField>

              <FonctionPopperDefinition
                anchorEl={anchorElFonction}
                nom={param.parametre.nom}
                open={open}
                classes={classes}
                currentType={param.parametre.type}
                excludeFonctions={excludeFonctions}
                setAnchorEl={setAnchorElFonction}
                fonctionParams={tmpFonctionParams}
                setFonctionParams={setTmpFonctionParams}
              />
            </Grid>
          )}
          {isRenvoi && (
            <Grid item xs={12}>
              {
                <AutoCompleteFonctionTableur
                  label="Thème"
                  valeur={tmpThemeRenvoie || theme.nom}
                  options={themesNames}
                  setValeur={handleChangeTheme}
                />
              }
              {
                <AutoCompleteFonctionTableur
                  label="Convention"
                  valeur={tmpConventionRenvoie || cc.idcc + ' - ' + cc.titre}
                  options={idccAndLabels}
                  setValeur={handleCCChange}
                />
              }
              <Grid container direction="row" spacing={1}>
                <Grid item xs={6}>
                  <AutoCompleteFonctionTableur
                    label="Rôle"
                    valeur={tmpInputsOutputsRenvoie}
                    options={['INPUT', 'OUTPUT']}
                    setValeur={setTmpInputsOutputsRenvoie}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoCompleteFonctionTableur
                    label={tmpInputsOutputsRenvoie === 'OUTPUT' ? 'output' : 'input'}
                    valeur={tmpCompRenvoie}
                    options={tmpInputsOutputsRenvoie === 'INPUT' ? inputNames : outputNames}
                    setValeur={handleChangeComp}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" spacing={1}>
                <Grid item xs={8} style={{ marginTop: 10 }}>
                  <GreyButton variant="contained" size="medium" onClick={handleAddCustomInput}>
                    Ajouter Filtre
                  </GreyButton>
                </Grid>

                {(!!tmpCustomInputs.length || tmpThemeRenvoie || tmpConventionRenvoie) && tmpCompRenvoie && (
                  <Grid item xs={3} style={{ marginTop: 10 }}>
                    <GreyButton variant="contained" size="medium" onClick={handleRefreshValues}>
                      valeurs
                    </GreyButton>
                  </Grid>
                )}
                {!!renvoieResults.length && (
                  <RenvoieResultsPopper
                    renvoieResults={renvoieResults}
                    setAnchorEl={setAnchorElRenvoie}
                    open={anchorElRenvoie}
                    selectValues={selectValues}
                    currentRenvoieValues={tmpRenvoieValues}
                  />
                )}
              </Grid>
              {tmpCustomInputs.map((customInput, index) => (
                <Grid container key={customInput.nom}>
                  <Grid item xs={12} style={{ marginTop: 10 }}>
                    <AutoCompleteFonctionTableur
                      label={'Input ' + (index + 1)}
                      valeur={customInput.nom}
                      options={allInputs.filter(i => i !== tmpCompRenvoie)}
                      setValeur={e => setCustomInputNom(e, index)}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: 10 }}>
                    <Input
                      disabled
                      type="text"
                      value={
                        tmpRenvoieValues && tmpRenvoieValues.ids && tmpRenvoieValues.ids[customInput.nom]
                          ? tmpRenvoieValues.ids[customInput.nom]
                          : ''
                      }
                      getOptionLabel={f => f}
                      style={{ width: '100%' }}
                      label="Valeur de l'input"
                      placeholder={'Aucune Valeur'}
                    />
                  </Grid>
                </Grid>
              ))}
            </Grid>
          )}

          <Grid container direction="row" justify="flex-end">
            <Grid container direction="row" justify="flex-end">
              <AddItemButtons
                onSave={handleOnSave}
                onCancel={onCancel}
                showList={true}
                cancelDataTest={'ANNULER ELEMENT DE REFERENCE'}
                saveDataTest={'AJOUTER ELEMENT DE REFERENCE'}
                isSaveDisabled={isSaveDisabled}
                addDataTest={'data-test-butouns-pop'}
              />
            </Grid>
          </Grid>

          {/*
          isVariableContext() && <Grid>
            <InputLabel id='funciton_name_label'>Fonction</InputLabel>
            <Autocomplete
              value={tmpOrigine}
              inputValue={tmpOrigine?.replace('_', ' ')}
              data-test='double_composant'
              options={valeurContext}
              getOptionLabel={f => f}
              style={{ width: '100%' }}
              onChange={(e, value) => {
                setTmpOrigine(value ? value : '')
              }}
              renderInput={params => {
                return <TextField {...params} label='Selectionner input' />
              }}
            />
          </Grid>
        }*/}
        </Grid>
      </Grid>
    </Grid>
  )
}
